// Capacitor native shell glue: status bar, splash hide, Android back button.
// No-op on web (Capacitor.isNativePlatform() is false there). Ported from the
// reference games' native/setupNativeShell.js, trimmed to what this build
// actually has — no gamePause/i18n coupling (neither exists here yet).

import { App as CapacitorApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { SplashScreen } from "@capacitor/splash-screen";
import { StatusBar, Style } from "@capacitor/status-bar";
import { AdMob } from "@capacitor-community/admob";
import { t } from "../i18n.ts";

export async function setupNativeShell(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  if (Capacitor.getPlatform() === "android") {
    await CapacitorApp.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
        return;
      }
      if (window.confirm(t("exitConfirm"))) CapacitorApp.exitApp();
    });
  }

  try {
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: "#07080f" });
    await StatusBar.setOverlaysWebView({ overlay: true });
    if (Capacitor.getPlatform() === "android") await StatusBar.hide();
  } catch {
    /* StatusBar unavailable on some WebViews */
  }

  window.setTimeout(() => {
    SplashScreen.hide().catch(() => {});
  }, 300);

  // AdMob app ID lives in AndroidManifest.xml (the SDK reads it from there);
  // per-placement unit IDs are in gamzone/ads/config.ts, used by AdSlot.tsx etc.
  try {
    await AdMob.initialize();
  } catch {
    /* AdMob unavailable on some builds */
  }
}
